export const SET_RMN_BANNERS_MAIN = 'SET_RMN_BANNERS_MAIN';

export const CLEAR_RMN_BANNERS = 'CLEAR_RMN_BANNERS';
